import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { tap, map, Observable, of } from 'rxjs';
import { User } from '../../data/model/user';
import { TotpDeviceApiService } from '../../shared/api/services/totp-device-api.service';
import { DialogsService } from '../../shared/dialogs/dialogs-service';
import { SharedModule } from '../../shared/shared.module';

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: 'app-register-totp-device-dialog',
  templateUrl: './register-totp-device-dialog.component.html',
  styleUrls: ['./register-totp-device-dialog.component.scss']
})
export class RegisterTotpDeviceDialogComponent implements OnInit{

  constructor(
    private formBuilder: FormBuilder,
    public sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    protected dialogsService: DialogsService,
    private apiService: TotpDeviceApiService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<RegisterTotpDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: User }
  ) {}

 

  static error: ValidationErrors;
  showOTPForm = false;
  entityFormGroup!: FormGroup;
  otpFormGroup!: FormGroup;




  ngOnInit(): void {
    this.entityFormGroup = this.formBuilder.group({
      name: [this.data.user.username]
    });

    this.otpFormGroup = this.formBuilder.group({
      otp_code: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[0-9]{6}$/)
        ]
      ]
    });
  }

  generateOtpError() {
    this.entityFormGroup.markAllAsTouched();

    if (this.entityFormGroup.valid){
      this.apiService.setupOTP(this.entityFormGroup.value).subscribe(
        (response) => {
          this.showOTPForm = true;
        },
        (error) => {
          console.log(error);
        }
      )
    } else {
      Object.keys(this.entityFormGroup.controls).forEach(key => {
        const controlErrors = this.entityFormGroup.get(key)?.errors;
        console.log(key, controlErrors); // Logs the control name and its errors
      });
    }
  }
  qrImageUrl: SafeUrl | null = null;

  generateOtp() {
    this.entityFormGroup.markAllAsTouched();
  
    if (this.entityFormGroup.valid) {
      this.apiService.setupOTP(this.entityFormGroup.value).subscribe(
        (response: any) => {
          this.qrImageUrl = this.sanitizer.bypassSecurityTrustUrl(
            URL.createObjectURL(response));
          this.showOTPForm = true;
          this.cdr.detectChanges();
        },
        (error) => {
          if (error.error='"no_unconfirmed_device"') {
            this.generateOtpError();
          }
          console.error(error);
        }
      );
    }
  }

  clodeDialog(){
    this.dialogRef.close();
  }

  confirmOtp() {
    this.otpFormGroup.markAllAsTouched();

    if (this.otpFormGroup.valid){
      this.apiService.confirmOtp(this.otpFormGroup.value).subscribe(
        (response) => {
          this.showConfirmMessage();
          this.dialogRef.close();
        },
        (error) => {
          if (error.error.error=='no_unconfirmed_device') {
            this.showConfirmMessage();
            this.dialogRef.close();
          } else{
            this.showFailConfirmMessage();
          }
          //this.showFailConfirmMessage();
          console.log(error);
        }
      )
    } else {
      Object.keys(this.otpFormGroup.controls).forEach(key => {
        const controlErrors = this.otpFormGroup.get(key)?.errors;
        console.log(key, controlErrors); // Logs the control name and its errors
      });
    }
  }

  deleteMessage(): Observable<string> {
    return of("Sei sicuro di voler disabilitare l'otp?");
  }

  showConfirmMessage() {
    this.snackBar.open('OTP attivato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-success"]
    });
  }

  showFailConfirmMessage() {
    this.snackBar.open('OTP non attivato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-fail"]
    });
  }

  showSuccessMessage() {
    this.snackBar.open('OTP disabilitato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-success"]
    });
  }

  showFailMessage() {
    this.snackBar.open('OTP non disabilitato', 'Chiudi', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      direction:'ltr',
      panelClass: ["snackBar-fail"]
    });
  }



  disableOtp() {
    this.deleteMessage()
      .pipe(
        tap((message) =>
          this.dialogsService
            .cancelConfirm$({ message })
            .pipe(
              map(() => {
                //this.loading$=true;
                this.apiService.disableOtp().subscribe(
                  (response) => {
                    this.showSuccessMessage();
                    this.dialogRef.close();
                  },
                  (error)=>{
                    this.showFailMessage();
                    console.log(error);
                  }
                );
              })
            )
            .subscribe()
        )
      )
      .subscribe();
  }

}
